
import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '@/pages/demo.vue'
import appMain from '@/pages/appMain.vue'
import home from '@/pages/home.vue'
import list from '@/pages/zhengCe.vue'
import detail from '@/pages/zhengCeDetail.vue'
 
import mediaDetails from '@/pages/mediaDetails.vue'
Vue.use(VueRouter) 
const routes = [
  // {
  //   path: '/home',
  //   name: 'appMain',
  //   component: appMain
  // },
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('@/pages/zhengCe.vue')
  },
  {
    path: '/briefing',
    name: 'briefing',
    component: () => import('@/pages/jianBao.vue')
  },
  {
    path: '/briefingDetail/:body/',
    name: 'briefingDetail',
    component: () => import('@/pages/jianBaoDetail.vue')
  },
  {
    path: '/policyDetail/:body/',
    name: 'policyDetail',
    component: () => import('@/pages/zhengCeDetail.vue')
  },
  {
    path: '/mediaDetails/:body/',
    name: 'mediaDetails',
    component: () => import('@/pages/mediaDetails.vue')
  },
  {
    path: '/buTie',
    name: 'buTie',
    component: () => import('@/pages/buTie.vue')
  },
  {
    path: '/gaoXin',
    name: 'gaoXin',
    component: () => import('@/pages/gaoXin.vue')
  },
  {
    path: '/zhuanJing',
    name: 'zhuanJing',
    component: () => import('@/pages/zhuanJing.vue')
  },
  {
    path: '/zhengCeMap',
    name: 'zhengCeMap',
    component: () => import('@/pages/zhengCeMap.vue')
  },
  {
    path: '/zhengCeHot',
    name: 'zhengCeHot',
    component: () => import('@/pages/zhengCeHot.vue')
  },
  {
    path: '/zhengCePiPei',
    name: 'zhengCePiPei',
    component: () => import('@/pages/zhengCePiPei.vue')
  },
  {
    path: '/youQingLink',
    name: 'youQingLink',
    component: () => import('@/pages/youQingLink.vue')
  }
  
]
 
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router